<style>
	.summary-organ-select-ul li{
		background: none !important;
		overflow: hidden;
	}
	.summary-filter-p{
		margin: .3em 1em;
	}
	.summary-company-select-ul li label input[type="checkbox"] {
		position: absolute;
		top: 10px;
		right: 15px;
	}
	.summary-company-select-ul li label input[type="checkbox"]:after{
		content: url(../assets/allorderbill/uncheck.png);
	}
	.summary-company-select-ul li label input[type="checkbox"]:checked:after{
		content: url(../assets/allorderbill/check.png);
	}
</style>
<template>
	<div>
		<transition name="slide">
			<div v-show="show" class="summary-wrapper">
				<navbar title="金额汇总-选择机构"></navbar>
				<w-search
					v-show="true"
					v-model="searchKey"
					placeholder="可搜索门店编号、名称、助记符"
					:showFilterBtn="false"
					@on-serch="onSearch"
				></w-search>
				<div class="summary-filter-shell" style="background:none">
					<div v-for = "(organDetail, index) in organDetails">
						<p class="summary-filter-p">{{organDetail.phonetic}}</p>
						<ul class="summary-filter-ul summary-company-select-ul">
							<li>
								<label>
									{{organDetail.name}}
									<input type="checkbox" name="selectOrgan" v-if="!organDetail.organId"
										@change="onSelectAll($event)"
										:checked="organIds.length === organDetails.length - 1"
									>
									<input type="checkbox" name="selectOrgan" v-if="organDetail.organId"
										@change="onSelectOrganChange(organDetail.organId, $event)"
										:checked="organIds.includes(organDetail.organId)"
									>
								</label>
							</li>
						</ul>
					</div>
					<a class="summary-filter-btn" @click="confirm">确定</a>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		// selectedName: String
		restaurantId: String
	},
	data () {
		return {
			show: false,
			organIds: [],
			organDetails: [],
			searchKey: ''
		}
	},
	components: {
		'navbar': NavBar
	},
	created () {},
	methods: {
		open (organList, organIds) {
			var arrTemp = [{
				create_time: null,
				enable_flag: true,
				id: -1,
				modify_time: null,
				name: '全部机构',
				organId: '',
				phonetic: 'QBJG'
			}]
			organList.forEach(function (one) {
				arrTemp.push(one)
			})
			this.show = !this.show
			this.organDetails = arrTemp
			this.organIds = organIds
		},
		onSelectOrganChange (organId, e) {
			const checked = e.target.checked
			if (!organId) {
				this.selectAll(checked)
				return
			}

			if (checked) {
				if (!this.organIds.includes(organId)) {
					this.organIds.push(organId)
				}
			} else {
				var index = this.organIds.indexOf(organId)
				if (index > -1) {
					this.organIds.splice(index, 1)
				}
			}
		},
		onSelectAll (e) {
			console.log(e)
			const checked = e.target.checked
			this.organIds = []
			if (checked) {
				this.organDetails.forEach(item => {
					if (item.organId.length) {
						this.organIds.push(item.organId)
					}
				})
			}
		},
		confirm () {
			this.show = !this.show
			this.$emit('selectedOrgan', this.organIds)
		},
		onSearch () {
			this.$http.get('/cldEdi/business/getShopList.do?restraurantId=' + this.restaurantId + '&keyword=' + this.searchKey).then(res => {
				var arrTemp = [{
					create_time: null,
					enable_flag: true,
					id: -1,
					modify_time: null,
					name: '全部机构',
					organId: '',
					phonetic: 'QBJG'
				}]
				this.organDetails = [...arrTemp, ...res.body.data]
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// OrganSelectM.vue?425559c8